import React , { useState } from 'react';
import Select from "react-select";
import {ColorPicker} from '../../../libs/components/ColorPicker';
import { ExpanderList, Expander } from "../../../libs/components/Expander";
import GridContainer from "./GridContainer";
import { Input ,Label ,FileUploader , FileSelector}from '../../../libs/components/FormControls';
import ActionsTable from '../ActionsTable/ActionsTable';
import ImageListContainer from '../ImagePreviewList/ImageList.container';
import ActionsPanelContainer from './ActionsPanelContainer';
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import { flexbox } from '@material-ui/system';

export default function CardSettingsPanel({
  cardSettings,
  // actions,
  // removeAction,
  // addCardAction, 
  // updateAction, 
  // setCardActions, 
  updateAvatar,
  updateBackgroundImage,
  updateHeaderImage,
  editCardSetting
}){

    console.log('card settings props');
    console.log(cardSettings)
    console.log(cardSettings.backgroundSettings.backgroundColor)
    //console.log(actions)
    
    const cardBackgroundColor = {hex : cardSettings.backgroundSettings.backgroundColor};
    const cardTitleColor = {hex : cardSettings.headerSettings.titleColor};
    const cardsubtitleColor = {hex : cardSettings.headerSettings.subtitleColor};
    const bodyfontColor = {hex : cardSettings.bodySettings.fontColor};
  
    return(
        <ExpanderList>
          <Expander title={"Header Settings"}>
            <form encType="multipart/form-data">
              <GridContainer>
                <Label>Header Image:</Label>
                {/* <FileUploader uploadUrl={"/upload/image"} onUploadCompleteCallback={(value) => editCardSetting("headerSettings","headerImage",value)} /> */}
                <FileSelector onFileSelected={(file) => updateHeaderImage(file)} />
                <Label>Logo:</Label>
                {/* <FileUploader uploadUrl={"/upload/avatar"} onUploadCompleteCallback={(value) => editCardSetting("headerSettings","avatar",value)} /> */}
                <FileSelector onFileSelected={(file) => updateAvatar(file)} />
                <Label>Title:</Label>
                <Input value={cardSettings.headerSettings.title} onChange={(e) => editCardSetting("headerSettings","title",e.target.value)} type="text"></Input>
                <Label>Title Font Weight</Label>
                <Input style={{height:'1.2px'}} value={cardSettings.headerSettings.titleFontWeight} onChange={(e) => editCardSetting("headerSettings","titleFontWeight",e.target.value)} type='range' step='100' min='100' max='900'></Input>
                <Label>Title Color:</Label>
                <ColorPicker color={cardTitleColor} onChangeCallback={(color)=>{
                  editCardSetting("headerSettings","titleColor",color.hex)
                }}
                />
                <Label>Sub Title:</Label>
                <Input value={cardSettings.headerSettings.subTitle} onChange={(e) => editCardSetting("headerSettings","subTitle",e.target.value)} type="text"></Input>
                <Label>Subtitle Color:</Label>
                <ColorPicker color={cardsubtitleColor} onChangeCallback={(color)=>{
                  editCardSetting("headerSettings","subtitleColor",color.hex)
                }}
                />
              </GridContainer>
            </form>
          </Expander>
          <Expander title={"Background Settings"}>
            <form  encType="multipart/form-data">
              <GridContainer>
                <Label>Image:</Label>
                <FileSelector onFileSelected={(file) => updateBackgroundImage(file)} />
                <Label>Color:</Label>
                <ColorPicker color={cardBackgroundColor} onChangeCallback={(color)=>{
                  editCardSetting("backgroundSettings","backgroundColor",color.hex)
                }}
                />
              </GridContainer>
            </form>
          </Expander>
          <Expander title={"Body Settings"}>
              <GridContainer>
                <Label>Font color:</Label>
                <ColorPicker color={bodyfontColor} onChangeCallback={(color)=>{
                  editCardSetting("bodySettings","fontColor",color.hex)
                }}
                />
                <Label>Text Direction:</Label>
                <div style={{display:'flex',flexDirection:'row'}}>
                  <span>
                    Left to Right
                  </span>
                  <Toggle 
                  style={{margin:'5px'}}
                  icons={false}
                  defaultChecked={cardSettings.bodySettings.direction === 'rtl' ? true : false}
                  onChange={(e)=> {
                    const direction = e.target.checked ? 'rtl' : 'ltr';
                    editCardSetting("bodySettings","direction",direction);
                  }}
                  />
                  <span>
                    Right to Left 
                  </span>
                </div>
              </GridContainer>  
          </Expander>
          <Expander title={"Actions Settings"}>
            <ActionsPanelContainer/>
          </Expander>
          <Expander title={"Business Details Settings"}>
            <GridContainer>
                <Label>Services Title:</Label>
                <Input value={cardSettings.detailsSettings.servicesTitle} onChange={(e) => editCardSetting("detailsSettings","servicesTitle",e.target.value)} type='text'></Input>
                <Label>Opening Hours Title:</Label>
                <Input value={cardSettings.detailsSettings.openingHoursTitle} onChange={(e) => editCardSetting("detailsSettings","openingHoursTitle",e.target.value)} type='text'></Input>
            </GridContainer>
          </Expander>
          <Expander title={"Gallery Images"}>
            <ImageListContainer />
          </Expander>
          <Expander title={"Share Settings"}>
            <GridContainer>
                <Label>Title:</Label>
                <Input value={cardSettings.shareSettings.title} onChange={(e) => editCardSetting("shareSettings","title",e.target.value)} type='text'></Input>
            </GridContainer>
          </Expander>
          <Expander title={"Footer Settings"}>
            <GridContainer>
                <Label>Title:</Label>
                <Input value={cardSettings.footerSettings.title} onChange={(e) => editCardSetting("footerSettings","title",e.target.value)} type='text'></Input>
                <Label>Button Text:</Label>
                <Input value={cardSettings.footerSettings.buttonText} onChange={(e) => editCardSetting("footerSettings","buttonText",e.target.value)} type='text'></Input>
                <Label>Link:</Label>
                <Input value={cardSettings.footerSettings.link} onChange={(e) => editCardSetting("footerSettings","link",e.target.value)} type='text'></Input>
            </GridContainer>
          </Expander>
          </ExpanderList>
    )
}

